export enum BlindPanelSide {
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}

export enum CaseworkSuperType {
  CABINET = "CABINET",
  SHELVING = "SHELVING",
}

export enum CabinetType {
  BASE_CABINET = "BASE_CABINET",
  UPPER_CABINET = "UPPER_CABINET",
  TALL_CABINET = "TALL_CABINET",
  FILLER_PANEL = "FILLER_PANEL",
}

export enum CaseworkShapeType {
  NONE = "NONE",
  L_SHAPED = "L_SHAPED",
  ANGLED = "ANGLED",
}

export enum UpperCabinetSubType {
  GENERAL = "GENERAL",
  REFRIGERATOR = "REFRIGERATOR",
  MICROWAVE = "MICROWAVE",
  WALL_BLIND_SQUARE_CORNER = "WALL_BLIND_SQUARE_CORNER",
}

export enum ShelvingType {
  CLOSET_SHELF = "CLOSET_SHELF",
}

export enum CaseworkTypeName {
  WALL = "WALL",
  WALK_IN_SHOWER = "WALK_IN_SHOWER",
  SHOWER = "SHOWER",
  WC = "WC",
  CABINET = "CABINET",
  CABINET_END_PANEL = "CABINET_END_PANEL",
  ISLAND = "ISLAND",
  VANITY = "VANITY",
  CHASE = "CHASE",
  FULL_SHELVES = "FULL_SHELVES",
  SHELF = "SHELF",
  BENCH = "BENCH",
  SOFFIT = "SOFFIT",
  TRAY_CEILING = "TRAY_CEILING",
  CLOSET = "CLOSET",
  ROUGH_IN = "ROUGH_IN",
  OPEN_BELOW_EDGE = "OPEN_BELOW_EDGE",
  RAILING = "RAILING",
}

export enum PlanNoteOrientation {
  HORIZONTAL = "HORIZONTAL",
  VERTICAL = "VERTICAL",
}
